module.exports = __webpack_public_path__ + "static/media/home-banner.7ea6fef7.png";